import React from "react"

import { cn } from "#Utils/cn"

type LoadingSpinnerSize = "sm" | "md" | "lg"

type LoadingSpinnerProps = {
  size?: LoadingSpinnerSize
  text?: string
  spinnerClassName?: string
  textClassName?: string
}

const sizeMap: Record<LoadingSpinnerSize, string> = {
  sm: "c-spinner__img--sm",
  md: "c-spinner__img--md",
  lg: "c-spinner__img--lg",
}

const LoadingSpinner = ({
  size,
  text = "Loading",
  spinnerClassName = "",
  textClassName = "",
}: LoadingSpinnerProps) => {
  const normalizedSpinnerClassName = spinnerClassName.trim()

  return (
    <span className="c-spinner">
      <span
        className={cn(
          "text-content-muted",
          "c-spinner__img",
          size && sizeMap[size],
          normalizedSpinnerClassName,
        )}
      ></span>
      <span className={cn("c-spinner__text text-content-muted", textClassName)}>{text}</span>
    </span>
  )
}

export type { LoadingSpinnerProps, LoadingSpinnerSize }
export default LoadingSpinner
